if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          container: ".m-main-product--wrapper",
          slider: ".swiper-container",
          sliderPagination: ".swiper-pagination",
          sliderPrevEl: ".swiper-button-prev",
          sliderNextEl: ".swiper-button-next",
          navSlider: ".nav-swiper-container",
          medias: [".m-product-media--item"],
          mediaWrapper: ".m-product-media--wrapper",
          mediaZoomIns: [".m-product-media__zoom-in"],
          videos: [".media-video"],
          variantIdNode: '[name="id"]',
          featuredImage: ".m-product-media",
        };

        this.productSlideCommonConfigs = {
          loop: false,
          speed: 0,
          allowTouchMove: false,
        };

        this.productSlideConfigs = {
          mobile: { autoHeight: true, loop: true },
          "quick-view": { autoHeight: true },
          "layout-5": {
            ...this.productSlideCommonConfigs,
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
              768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 },
            },
          },
          "layout-7": {
            ...this.productSlideCommonConfigs,
            slidesPerView: 3,
            speed: 500,
            centeredSlides: true,
          },
        };

        this.container = this.closest(this.selectors.container);
        this.domNodes = queryDomNodes(this.selectors, this);
        this.enableVideoAutoplay = this.dataset.enableVideoAutoplay === "true";
        this.enableImageZoom = this.dataset.enableImageZoom === "true";
        this.enableVariantGroupImages = this.dataset.enableVariantGroupImages === "true";
        this.show_featured_media = this.dataset.showFeaturedMedia === "true";
        this.onlyMedia = this.dataset.onlyMedia === "true";
        if (this.container) {
          this.view = this.container.dataset.view || "product-template";
        }
        this.section = this.closest(`[data-section-id="${this.sectionId}"]`);
        this.layout = this.dataset.layout;
        this.fetchProductData();
      }

      getProductSliderConfig(layout) {
        const conf = this.productSlideConfigs[layout] || this.productSlideConfigs["layout-4"];
        return { ...this.productSlideCommonConfigs, ...conf };
      }

      async fetchProductData() {
        try {
          const product = await this.getProductJson();
          if (product) {
            this.productData = product;
            this.setupData();
          }
        } catch (error) {
          console.error("Error fetching product:", error);
        }
      }

      setupData() {
        this.productHandle = this.dataset.productHandle;
        this.productUrl = this.dataset.productUrl;
        const { variants } = this.productData || {};
        if (!this.productData || !variants) return;

        const variantIdNode = this.container.querySelector(this.selectors.variantIdNode);
        if (!variantIdNode) return;

        let currentVariantId = Number(variantIdNode.value) || this.productData.selected_or_first_available_variant.id;
        const currentVariant = variants.find((v) => v.id === currentVariantId) || variants[0];
        this.productData.initialVariant = currentVariant;

        if (!this.productData.selected_variant && variantIdNode.dataset.selectedVariant) {
          const selectedVariantId = Number(variantIdNode.dataset.selectedVariant);
          this.productData.selected_variant = variants.find((v) => v.id === selectedVariantId);
        }

        this.init();
      }

      init() {
        const variantPicker = this.container.querySelector("variant-picker");

        const commonInit = () => {
          this.handleAutoplayVideo();
          if (!variantPicker) {
            this.initPhotoswipe();
            this.handleSlideChange();
            this.removeAttribute("data-media-loading");
            this.firstElementChild.style.opacity = 1;
          }
        };

        switch (this.view) {
          case "product-template":
            this.mediaMode = "grid-column";
            this.handlePhotoswipe();
            this.initPhotoswipe();
            this.initSlider();
            break;
          case "featured-product":
            this.initSlider();
            break;
          case "card":
          case "sticky-atc":
          case "quick-view":
            this.mediaMode = "featured-image";
            if (this.view === "quick-view") this.initSlider();
            break;
          default:
            console.warn("Unknown product view: ", this, this.view);
        }

        this.listenToVariantChange();

        commonInit();
      }

      initSlider() {
        if (!this.domNodes.slider) return;

        this.mediaMode = "slider";
        const { slider, sliderPagination, navSlider } = this.domNodes;

        const initialSlide =
          (this.productData.initialVariant &&
            this.productData.initialVariant.featured_media &&
            !this.show_featured_media &&
            this.productData.initialVariant.featured_media.position - 1) || 0;

        this.navSlider = navSlider
          ? new MinimogLibs.Swiper(navSlider, this.getNavSliderConfig(initialSlide))
          : null;

        this.slider = new MinimogLibs.Swiper(slider, this.getMainSliderConfig(initialSlide, { sliderPagination }));

        this.bindNavigationButtons();

        this.updateThumbArrowVisibility();

        this.registerAsMobileGallery();

        if (!this.enableVariantGroupImages) this.handleSlideChange();
      }

      bindNavigationButtons() {
        // Slider pijlen
        const prevBtn = this.querySelector(".swiper-button-prev");
        const nextBtn = this.querySelector(".swiper-button-next");

        if (prevBtn) {
          prevBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.slider && this.slider.slidePrev();
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.slider && this.slider.slideNext();
          });
        }

        // Thumbnail pijlen
        const thumbPrev = this.querySelector(".m-thumb-arrow--prev");
        const thumbNext = this.querySelector(".m-thumb-arrow--next");

        if (thumbPrev && this.navSlider) {
          thumbPrev.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.navSlider.isBeginning) {
              this.navSlider.slideTo(this.navSlider.slides.length - 1);
            } else {
              this.navSlider.slidePrev();
            }
            this.updateThumbArrows(thumbPrev, thumbNext);
          });
        }
        if (thumbNext && this.navSlider) {
          thumbNext.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.navSlider.isEnd) {
              this.navSlider.slideTo(0);
            } else {
              this.navSlider.slideNext();
            }
            this.updateThumbArrows(thumbPrev, thumbNext);
          });
        }
        if (this.navSlider && (thumbPrev || thumbNext)) {
          this.navSlider.on("slideChange", () => this.updateThumbArrows(thumbPrev, thumbNext));
          this.updateThumbArrows(thumbPrev, thumbNext);
        }
      }

      updateThumbArrows(prevBtn, nextBtn) {
        if (prevBtn) prevBtn.classList.remove("is-disabled");
        if (nextBtn) nextBtn.classList.remove("is-disabled");
      }

      updateThumbArrowVisibility() {
        const thumbPrev = this.querySelector(".m-thumb-arrow--prev");
        const thumbNext = this.querySelector(".m-thumb-arrow--next");
        if (!thumbPrev || !thumbNext || !this.navSlider) return;

        const totalSlides = this.productData?.media?.length || 0;
        const isMobile = window.innerWidth < 768;
        const threshold = isMobile ? 4 : 6;
        const show = totalSlides > threshold;

        thumbPrev.style.setProperty("display", show ? "" : "none", "important");
        thumbNext.style.setProperty("display", show ? "" : "none", "important");

        if (!this._resizeListenerAdded) {
          this._resizeListenerAdded = true;
          window.addEventListener("resize", () => {
            const isMobileNow = window.innerWidth < 768;
            const thresholdNow = isMobileNow ? 4 : 6;
            const showNow = totalSlides > thresholdNow;
            thumbPrev.style.setProperty("display", showNow ? "" : "none", "important");
            thumbNext.style.setProperty("display", showNow ? "" : "none", "important");
          });
        }
      }
      listenToVariantChange() {
        const productId = this.dataset.productId;
        if (!productId || !window.MinimogEvents) return;

        window.MinimogEvents.subscribe(`${productId}__VARIANT_CHANGE`, (variant) => {
          if (variant && this.slider && this.slider.wrapperEl) {
            this.setActiveMedia(variant);
          }
        });
      }

      registerAsMobileGallery() {
        if (!this.container) return;
        const variantPicker = this.container.querySelector("variant-picker");
        if (!variantPicker) return;

        // Wacht tot de variant-picker volledig geïnitialiseerd is
        const doRegister = () => {
          variantPicker.mediaGalleryMobile = this;
          variantPicker.mediaGallery = this;
          if (typeof variantPicker.setupMediaGallery === "function") {
            try { variantPicker.setupMediaGallery(); } catch(e) {}
          }
        };

        if (variantPicker.mediaGallery) {
          doRegister();
        } else {
          const interval = setInterval(() => {
            if (variantPicker.mediaGallery) {
              clearInterval(interval);
              doRegister();
            }
          }, 50);
          setTimeout(() => clearInterval(interval), 3000);
        }
      }

      getNavSliderConfig(initialSlide) {
        return {
          loop: false,
          initialSlide,
          slidesPerView: "auto",
          freeMode: true,
          spaceBetween: 8,
          threshold: 2,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          on: {
            init: () => {
              if (this.domNodes.navSlider) this.domNodes.navSlider.style.opacity = 1;
            },
          },
        };
      }

      getMainSliderConfig(initialSlide, { sliderPagination }) {
        const thumbsConfig = this.navSlider ? { thumbs: { swiper: this.navSlider } } : {};
        return {
          loop: !this.enableVariantGroupImages,
          speed: 350,
          allowTouchMove: true,
          initialSlide,
          autoHeight: true,
          threshold: 2,
          pagination: {
            el: sliderPagination || null,
            clickable: true,
            type: "bullets",
          },
          ...thumbsConfig,
          on: {
            init: () => {
              if (this.domNodes.slider) this.domNodes.slider.style.opacity = 1;
              this.domNodes = queryDomNodes(this.selectors, this.container);
              requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
            },
          },
        };
      }

      handleSlideChange() {
        if (!this.slider) return;
        this.slider.on("slideChange", (swiper) => {
          window.pauseAllMedia(this);
          const { slides, activeIndex } = swiper;
          const activeSlide = slides[activeIndex];
          if (activeSlide) this.playActiveMedia(activeSlide);

          if (this.navSlider) {
            const realIndex = typeof swiper.realIndex !== "undefined" ? swiper.realIndex : activeIndex;
            this.navSlider.slideTo(realIndex);
            const thumbPrev = this.querySelector(".m-thumb-arrow--prev");
            const thumbNext = this.querySelector(".m-thumb-arrow--next");
            if (thumbPrev || thumbNext) this.updateThumbArrows(thumbPrev, thumbNext);
          }

          const visibleSlides = [activeIndex];
          if (["layout-5", "layout-7"].includes(this.layout)) visibleSlides.push(activeIndex + 1);
          const hasModel = visibleSlides.some((i) => slides[i]?.dataset?.mediaType === "model");
          this.toggleSliderDraggableState(!hasModel);
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.slider.allowTouchMove !== isDraggable) this.slider.allowTouchMove = isDraggable;
      }

      handleAutoplayVideo() {
        const playVideo = (el) => {
          const mediaType = el.dataset.mediaType;
          if (mediaType === "video" || mediaType === "external_video") {
            const dm = el.querySelector("deferred-media");
            if (dm && dm.dataset.autoPlay === "true") dm.loadContent(false);
          }
        };
        if (this.mediaMode === "slider" && this.slider) {
          const activeSlide = this.slider.slides[this.slider.activeIndex];
          if (activeSlide) playVideo(activeSlide);
        } else {
          this.querySelectorAll(".m-product-media--item").forEach(playVideo);
        }
      }

      playActiveMedia(selected) {
        const dm = selected.querySelector("deferred-media");
        if (!dm || dm.dataset.autoPlay !== "true") return;
        if (!dm.hasAttribute("loaded")) dm.loadContent(false);
        const el = dm.querySelector("video, model-viewer, iframe");
        if (!el) return;
        if (el.classList.contains("js-youtube") || el.classList.contains("js-vimeo")) {
          const platform = el.classList.contains("js-youtube") ? "youtube" : "vimeo";
          const param = platform === "youtube" ? "mute=1" : "muted=1";
          el.src += (el.src.includes("?") ? "&" : "?") + `autoplay=1&${param}`;
        } else if (el.play) el.play();
      }

      handlePhotoswipe(customData = []) {
        if (!this.enableImageZoom) return;
        const medias = [...this.querySelectorAll(".m-product-media--item:not(.swiper-slide-duplicate)")];
        const data = medias.map((media) => {
          const { mediaType, index: id } = media.dataset;
          if (mediaType === "image") {
            const { mediaSrc: src, mediaWidth, mediaHeight, mediaAlt: alt } = media.querySelector(".m-product-media").dataset;
            return { src, width: parseInt(mediaWidth), height: parseInt(mediaHeight), alt, id };
          }
          return { html: `<div class="pswp__${mediaType}">${media.innerHTML}</div>`, type: mediaType, id };
        });

        this.lightbox = new MinimogLibs.PhotoSwipeLightbox({
          dataSource: customData.length ? customData : data,
          bgOpacity: 1, close: false, zoom: false, arrowNext: false, arrowPrev: false,
          counter: false, preloader: false,
          pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe,
        });

        this.lightbox.addFilter("thumbEl", (thumbEl, { id }) =>
          this.querySelector(`[data-index="${id}"]:not(.swiper-slide-duplicate) img`) || thumbEl
        );
        this.lightbox.addFilter("placeholderSrc", (placeholderSrc, { data: { id } }) => {
          const el = this.querySelector(`[data-index="${id}"]:not(.swiper-slide-duplicate) img`);
          return el ? el.src : placeholderSrc;
        });
        this.lightbox.on("change", () => {
          window.pauseAllMedia(this);
          if (this.slider) {
            const method = this.enableVariantGroupImages ? "slideTo" : "slideToLoop";
            this.slider[method](this.lightbox.pswp.currIndex, 100, false);
          }
        });
        this.lightbox.on("pointerDown", (e) => {
          if (this.lightbox.pswp.currSlide.data.type === "model") e.preventDefault();
        });

        const uiElements = [
          { name: "m-close", order: 11, isButton: true, html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>', onClick: (e, el, pswp) => pswp.close() },
          { name: "m-arrowNext", order: 12, isButton: true, html: '<svg fill="currentColor" width="14px" height="14px" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"/></svg>', onClick: (e, el, pswp) => pswp.next() },
          { name: "m-arrowPrev", order: 10, isButton: true, html: '<svg width="14px" height="14px" fill="currentColor" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"/></svg>', onClick: (e, el, pswp) => pswp.prev() },
        ];

        this.lightbox.on("uiRegister", () => {
          this.lightbox.pswp.ui.registerElement(uiElements[0]);
          if (!this.onlyMedia) uiElements.slice(1).forEach((el) => this.lightbox.pswp.ui.registerElement(el));
        });
      }

      initPhotoswipe() {
        if (!this.enableImageZoom) return;
        this.lightbox.init();
        addEventDelegate({
          selector: this.selectors.medias[0],
          context: this,
          handler: (e, media) => {
            e.preventDefault();
            if (media.classList.contains("media-type-image") || e.target.closest(this.selectors.mediaZoomIns[0])) {
              this.lightbox.loadAndOpen(Number(media.dataset.index) || 0);
            }
          },
        });
      }

      setActiveMedia(variant) {
        if (!variant) return;
        if (this.slider && this.slider.wrapperEl) {
          this.setActiveMediaForSlider(variant);
        } else if (this.mediaMode === "featured-image") {
          this.setActiveMediaForFeaturedImage(variant);
        } else {
          this.handleGalleryMode(variant);
        }
      }

      setActiveMediaForSlider(variant) {
        if (!variant.featured_media) return;
        const targetIndex = (variant.featured_media.position || 1) - 1;
        this.slider.slideToLoop(targetIndex, 300, false);
        if (this.navSlider) {
          requestAnimationFrame(() => {
            this.navSlider.slideTo(targetIndex);
            const thumbPrev = this.querySelector(".m-thumb-arrow--prev");
            const thumbNext = this.querySelector(".m-thumb-arrow--next");
            if (thumbPrev || thumbNext) this.updateThumbArrows(thumbPrev, thumbNext);
          });
        }
      }

      setActiveMediaForFeaturedImage(variant) {
        if (!variant.featured_image) return;
        const img = this.domNodes.featuredImage?.querySelector("img");
        if (img && variant.featured_image.src) img.src = variant.featured_image.src;
      }

      handleGalleryMode(variant) {
        if (this.view !== "featured-product" && variant?.featured_media) {
          const el = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }
      }

      getProductJson() {
        return fetch(window.Shopify.routes.root + `products/${this.dataset.productHandle}.js`)
          .then((r) => { if (!r.ok) throw new Error("Network error"); return r.json(); })
          .catch((e) => console.error("Fetch error:", e));
      }
    }
  );
}